export const SETTING_GROUPS = {
    SECURITY: {
        title: 'Individual Security Checks',
        icon: '🔍',
        dependsOn: 'turn_off_fpe',
        settings: [
            {
                key: 'check_camera',
                title: 'Virtual Camera Detection',
                description: 'Detect and block virtual cameras, screen recordings, and other spoofing attempts during live verification',
            },
// {
            //     key: 'closed_eyes',
            //     title: 'Closed Eyes Detection',
            //     description: 'Detect if the person has closed eyes during verification',
            //     apiMethods: { enable: 'enable_closed_eyes', disable: 'disable_closed_eyes' },
            // },
        ]
    },
};